import React from "react";
import ListSelector from "../../../../common/ListSelector";
import { Box } from "@mui/system";
import {
  propertyInsurances,
  personalInsurances,
} from "../../../../constants/constants";
const InsuranceList = () => {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <ListSelector list={propertyInsurances} />
      <ListSelector list={personalInsurances} />
    </Box>
  );
};

export default InsuranceList;
